import { Pipe, PipeTransform } from '@angular/core';
import { ExaminationType } from '../enums/examination/examination-type.enum';
import { ReservationExaminationStatus } from '../enums/examination/reservation-examination-status.enum';

@Pipe({
    name: 'examinationStatus',
})
export class ExaminationStatusPipe implements PipeTransform {
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transform(value: ReservationExaminationStatus, examinationType: ExaminationType = null): unknown {
        if (examinationType === ExaminationType.EXTERNAL_LABIS) {
            switch (value) {
                case ReservationExaminationStatus.OK:
                    return 'Zaključeno';
                case ReservationExaminationStatus.EMPTY:
                case ReservationExaminationStatus.MANDATORY_FIELD_MISSING:
                    return 'Ni zaključeno';
                default:
                    return '/';
            }
        } else {
            switch (value) {
                case ReservationExaminationStatus.OK:
                    return 'Izpolnjeno';
                case ReservationExaminationStatus.EMPTY:
                case ReservationExaminationStatus.MANDATORY_FIELD_MISSING:
                    return 'Ni izpolnjeno';
                default:
                    return '/';
            }
        }
    }
}
